import type React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { generateBreadcrumbs } from "../../utils/routing";
import styles from "./Breadcrumb.module.scss";

interface BreadcrumbProps {
  entityNames?: Record<string, string>;
  className?: string;
  separator?: React.ReactNode;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({
  entityNames = {},
  className = "",
  separator = "/",
}) => {
  const location = useLocation();
  const params = useParams();

  const breadcrumbs = generateBreadcrumbs(
    location.pathname,
    params as Record<string, string>,
    entityNames
  );

  if (breadcrumbs.length <= 1) {
    return null;
  }

  return (
    <nav
      aria-label="Breadcrumb"
      className={`${styles.breadcrumb} ${className}`}
    >
      <ol className={styles.breadcrumbList}>
        {breadcrumbs.map((item, index) => (
          <li key={item.path} className={styles.breadcrumbItem}>
            {index > 0 && (
              <span className={styles.breadcrumbSeparator} aria-hidden="true">
                {separator}
              </span>
            )}
            {item.isActive ? (
              <span className={styles.breadcrumbCurrent} aria-current="page">
                {item.label}
              </span>
            ) : (
              <Link to={item.path} className={styles.breadcrumbLink}>
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
